import React from 'react';

import OptimizedImage from '../../../OptimizedImage';

import Banner from './SpecialBanner';
import Icons from './Icons';

const StepDevelopment = () => {
  return (
    <div className="container">
      <div className="step third">
        <Banner />
        <div className="left-section">
          <div className="number-border">
            <div className="number-step">
              <span>3</span>
            </div>
          </div>
        </div>
        <div className="right-section">
          <h3 className="tt">Development phase</h3>
          <div className="content b-bottom">
            <div style={{ marginBottom: '40px' }}>
              <div className='mobileImage'>
                <OptimizedImage
                  src="pages/how-we-do/developmentphase_infographic_mobile.jpg"
                  className="img-fluid mobile"
                  alt="blockchain"
                />
              </div>
              <div className='desctopImage'>
                <OptimizedImage
                  src="pages/how-we-do/developmentphase_infographic.png"
                  className="img-fluid"
                  alt="blockchain"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <p>
                  We divide our work into two-week sequences called sprints.
                  Short enough to be responsive and flexible to your needs and
                  business requirements while long enough to deliver usable
                  parts of a system. During this phase our team will work on Web
                  or/and mobile application:
                </p>
                <ul>
                  <li>Design</li>
                  <li>Frontend</li>
                  <li>Backend</li>
                  <li>DevOps</li>
                </ul>
              </div>
              <div className="col-md-6">
                <p>
                  You will be able to verify, tryout and make changes in your
                  product during the process. Each sprint delivers value that
                  you can experience.
                </p>
                <p>The outcome is software that meets your expectations.</p>
              </div>
            </div>
          </div>
          <Icons
            yourRoleDetails="Participate in Scrum meetings and take an active role in planning, testing and feedback activities"
            outcomeDetails="A working product that meets customer requirements"
            ourRoleDetails="Manage the process, run meetings, deliver parts of product"
            durationDetails="Depends on the scope"
          />
        </div>
      </div>
    </div>
  );
};

export default StepDevelopment;
